import type React from 'react'
import type { Align, Shape, Theme } from '../../types/props.js'

export interface TabsGroupProps extends React.HTMLAttributes<HTMLElement> {
  data: {
    sectionTitle?: string
    theme: Theme
    shape: Shape
    align: Align
    tabs: {
      tabName: string
      tabContent: any[]
      children: (data: any) => React.ReactNode
    }[]
  }
}
